(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page__seedOfcategories"]) return;
  try {
    
$(document).ready(function() {
 
  const apiKey = 'testing';
  const pageSize = 10; // Change this to set the number of items to load at a time
  let page = 1;
  let isLoading = false;
  const urlParams = new URLSearchParams(window.location.search);
  const category_id = urlParams.get('id');
   const url = `https://ckapps.codingkloud.com/home-ground-garden/api/seeds-category/${category_id}/`;
  function loadItems() {
    if (isLoading) return; // Prevent multiple requests

    isLoading = true; // Set loading flag to true
    $('#loading').show(); // Show loading icon

    // Send AJAX request to API with the current page number
    $.ajax({
      url: url,
      type: 'GET',
      data: { page: page },
      headers: { 'X-API-KEY': apiKey },
      success: function(response) {
        // Append new items to the list
        response.data.items.forEach((item, index) => {
          const html = `
          <section class="sunFlowerSection">
            <div class="inner-container">
              <div class="descriptionBox">
                <div class="sunFlowerBackgroundImage" style="--bg-image:url('${item.Image}');">
                  <div class="sunFlowerBackgroundImageInner">
                    <h4>Heirloom | Non - Gmo</h4>
                    <h1>
                     ${item.Name}
                    </h1>
                    <h4>${item.category.name}</h4>
                  </div>
                </div>
                <div class="aboutOfSUnflower">
                  <h3>About ${item.Name}</h3>
                  <p>
                   ${item.Short_desc}
                  </p>
                </div>
                <div class="aboutOfSUnflowerRow">
                 ${
                            item.Attributes.map((attr_item, key) => {
                              return (
                                `
                                <div class="aboutOfSUnflowerInner">
                                    <div class="aboutOfSUnflowerInnerImage">
                                      <img src="${attr_item.attr_image}" />
                                    </div>
                                    <div class="aboutOfSUnflowerInnerContent">
                                      <p>${attr_item.attr_title}: <span> ${attr_item.attr_description} </span></p>
                                    </div>
                                 </div>
                                `
                              )
                            }).join('')
                          }
                  
                </div>
                <div class="descriptionBoxInnerRow">
                <h3>Description</h3>
                    ${
                            item.Description.map((desc_item, key) => {
                              return (
                                `
                                <div class="descriptionBoxInner">
                                 <h4>${desc_item.subtitle}</h4>
                                <p>
                                 ${desc_item.description}
                                </p>
                                </div>
                                `
                              )
                            }).join('')
                          }
                  </div>
              </div>
            </div>
</section>
          `;
          $('.ck_seeds_row-category').append(html);
        });

        page++; // Increment page number
        isLoading = false; // Reset loading flag
        $('#loading').hide(); // Hide loading icon
      }
    })
  }
    $(window).scroll(function() {
    if($(window).scrollTop() + $(window).height() >= $(document).height() - 100) {
      var isSearch = $('.ck_seeds_row-category').data('is-search')
      if(isSearch === true){
      console.log(isSearch)
        searchProducts(currentPage)
      }else{
        loadItems();
      }
    }
  });

  loadItems();

  //search api
  $(document).on('click', '.search-seeds-button_category' , function (e) {
    e.preventDefault();
    currentPage = 1;
    isLoading = false; // Set loading flag to true
    $('.ck_seeds_row-category').attr('data-is-search', true);
    $('.ck_seeds_row-category').empty(); // Clear previous search results
    var searchTerm = $('.search-seeds-input-category').val();
    searchProducts(searchTerm);
  }) 
  function searchProducts(searchTerm) {
     if (isLoading) return; // Prevent multiple requests
     isLoading = true; // Set loading flag to true
    var data = {
      search : searchTerm,
      page:currentPage
    }
     $.ajax({
      url: `https://ckapps.codingkloud.com/home-ground-garden/api/seeds-category/${category_id}/`,
      type: 'GET',
      data: data,
      headers: { 'X-API-KEY': apiKey },
      success: function(response) {
        if(response.code == 200 && response.data.items.length > 0 ){
          response.data.items.forEach((item, index) => {
          const html = `
             <section class="sunFlowerSection">
            <div class="inner-container">
              <div class="descriptionBox">
                <div class="sunFlowerBackgroundImage" style="--bg-image:url('${item.Image}');">
                  <div class="sunFlowerBackgroundImageInner">
                    <h4>Heirloom | Non - Gmo</h4>
                    <h1>
                     ${item.Name}
                    </h1>
                    <h4>${item.category.name}</h4>
                  </div>
                </div>
                <div class="aboutOfSUnflower">
                  <h3>About ${item.Name}</h3>
                  <p>
                   ${item.Short_desc}
                  </p>
                </div>
                <div class="aboutOfSUnflowerRow">
                 ${
                            item.Attributes.map((attr_item, key) => {
                              return (
                                `
                                <div class="aboutOfSUnflowerInner">
                                    <div class="aboutOfSUnflowerInnerImage">
                                      <img src="${attr_item.attr_image}" />
                                    </div>
                                    <div class="aboutOfSUnflowerInnerContent">
                                      <p>${attr_item.attr_title}: <span> ${attr_item.attr_description} </span></p>
                                    </div>
                                 </div>
                                `
                              )
                            }).join('')
                          }
                  
                </div>
                <div class="descriptionBoxInnerRow">
                <h3>Description</h3>
                    ${
                            item.Description.map((desc_item, key) => {
                              return (
                                `
                                <div class="descriptionBoxInner">
                                 <h4>${desc_item.subtitle}</h4>
                                <p>
                                 ${desc_item.description}
                                </p>
                                </div>
                                `
                              )
                            }).join('')
                          }
                  </div>
              </div>
            </div>
</section>
          `;
          $('.ck_seeds_row-category').append(html);
          currentPage++; // Increment page number
          isLoading = false; // reset the flag
        });
        }else{
            const html = `
            <div class="col-12 mb-5">
              <div class="card shadow p-5 text-center">
                    No Data Found              
              </div>
            </div>
            `
            $('.ck_seeds_row-category').append(html);
           isLoading = true; // set the flag to prevent further requests
        }
      }
    })
    
  }
  
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page__seedcategories"]) return;
  try {
    
$(document).ready(function () {
fetch('https://ckapps.codingkloud.com/home-ground-garden/api/categories', {
  method: 'GET',
  headers: {
    'X-API-KEY': 'testing'
  }
})
.then(response => response.json())
.then(data => {
   if(data.code == 200){
     let html
     data.data.items.map((item , key) => {
      $('.ck_categories_row').append(`
      <div class="category-sec-boxes">
  			<div class="category-sec-cards">
  				<div class="category-sec-cards-image">
  					<img src="${item.image}">
  				</div>
  				<div class="category-sec-cards-content">
  				  <div class="category-sec-cards-content-inner">
  					<h3> <a href="/pages/all-seeds-single-category/?category=${item.name}&id=${item.id}"> ${item.name} </a></h3>
  					<p> ${item.seed_count} Items</p>
  				  </div>
  				  <div class="category-sec-cards-content-inner-image">
  					<a href="javascript:void(0)"> <img src="https://cdn.shopify.com/s/files/1/0258/5483/6788/files/Vector5.png"> </a>
  				  </div>
  				</div>
  			</div>
  		</div>
      `)
     })
   }
})
.catch(error => {
  // Handle any errors that occurred
  console.error(error);
});

})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page__seedmain"]) return;
  try {
    
$(document).ready(function() {
  const url = 'https://ckapps.codingkloud.com/home-ground-garden/api/seeds';
  const apiKey = 'testing';
  const pageSize = 10; // Change this to set the number of items to load at a time
  let page = 1;
  let isLoading = false;
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('ID');
  function loadItems() {
    if (isLoading) return; // Prevent multiple requests

    isLoading = true; // Set loading flag to true
    $('#loading').show(); // Show loading icon

    // Send AJAX request to API with the current page number
    $.ajax({
      url: url,
      type: 'GET',
      data: { page: page },
      headers: { 'X-API-KEY': apiKey },
      success: function(response) {
        // Append new items to the list
        response.data.items.forEach((item, index) => {
          const html = `
          <section class="sunFlowerSection">
            <div class="inner-container">
              <div class="descriptionBox">
                <div class="sunFlowerBackgroundImage" style="--bg-image:url('${item.Image}');">
                  <div class="sunFlowerBackgroundImageInner">
                    <h4>Heirloom | Non - Gmo</h4>
                    <h1>
                     ${item.Name}
                    </h1>
                    <h4>${item.category.name}</h4>
                  </div>
                </div>
                <div class="aboutOfSUnflower">
                  <h3>About ${item.Name}</h3>
                  <p>
                   ${item.Short_desc}
                  </p>
                </div>
                <div class="aboutOfSUnflowerRow">
                 ${
                            item.Attributes.map((attr_item, key) => {
                              return (
                                `
                                <div class="aboutOfSUnflowerInner">
                                    <div class="aboutOfSUnflowerInnerImage">
                                      <img src="${attr_item.attr_image}" />
                                    </div>
                                    <div class="aboutOfSUnflowerInnerContent">
                                      <p>${attr_item.attr_title}: <span> ${attr_item.attr_description} </span></p>
                                    </div>
                                 </div>
                                `
                              )
                            }).join('')
                          }
                  
                </div>
                <div class="descriptionBoxInnerRow">
                <h3>Description</h3>
                    ${
                            item.Description.map((desc_item, key) => {
                              return (
                                `
                                <div class="descriptionBoxInner">
                                 <h4>${desc_item.subtitle}</h4>
                                <p>
                                 ${desc_item.description}
                                </p>
                                </div>
                                `
                              )
                            }).join('')
                          }
                  </div>
              </div>
            </div>
</section>
          `;
          $('.ck_seeds_row').append(html);
        });

        page++; // Increment page number
        isLoading = false; // Reset loading flag
        $('#loading').hide(); // Hide loading icon
      }
    })
  }
    $(window).scroll(function() {
    if($(window).scrollTop() + $(window).height() >= $(document).height() - 100) {
      var isSearch = $('.ck_seeds_row').data('is-search')
      if(isSearch === true){
      console.log(isSearch)
        searchProducts(currentPage)
      }else{
        loadItems();
      }
    }
  });

  loadItems();

  //search api
  $(document).on('click', '.search-seeds-button' , function (e) {
    e.preventDefault();
    currentPage = 1;
    $('.ck_seeds_row').attr('data-is-search', true);
    $('.ck_seeds_row').empty(); // Clear previous search results
    var searchTerm = $('.search-seeds-input').val();
     isLoading = false; // Set loading flag to false
    searchProducts(searchTerm);
  })
  function searchProducts(searchTerm) {
    if (isLoading) return; // Prevent multiple requests
    isLoading = true; // Set loading flag to true
    var data = {
      search : searchTerm,
      page:currentPage
    }
     $.ajax({
      url: `https://ckapps.codingkloud.com/home-ground-garden/api/seeds`,
      type: 'GET',
      data: data,
      headers: { 'X-API-KEY': apiKey },
      success: function(response) {
        if(response.code == 200 &&  response.data.items.length > 0){
          response.data.items.forEach((item, index) => {
          const html = `
             <section class="sunFlowerSection">
            <div class="inner-container">
              <div class="descriptionBox">
                <div class="sunFlowerBackgroundImage" style="--bg-image:url('${item.Image}');">
                  <div class="sunFlowerBackgroundImageInner">
                    <h4>Heirloom | Non - Gmo</h4>
                    <h1>
                     ${item.Name}
                    </h1>
                    <h4>${item.category.name}</h4>
                  </div>
                </div>
                <div class="aboutOfSUnflower">
                  <h3>About ${item.Name}</h3>
                  <p>
                   ${item.Short_desc}
                  </p>
                </div>
                <div class="aboutOfSUnflowerRow">
                 ${
                            item.Attributes.map((attr_item, key) => {
                              return (
                                `
                                <div class="aboutOfSUnflowerInner">
                                    <div class="aboutOfSUnflowerInnerImage">
                                      <img src="${attr_item.attr_image}" />
                                    </div>
                                    <div class="aboutOfSUnflowerInnerContent">
                                      <p>${attr_item.attr_title}: <span> ${attr_item.attr_description} </span></p>
                                    </div>
                                 </div>
                                `
                              )
                            }).join('')
                          }
                  
                </div>
                <div class="descriptionBoxInnerRow">
                <h3>Description</h3>
                    ${
                            item.Description.map((desc_item, key) => {
                              return (
                                `
                                <div class="descriptionBoxInner">
                                 <h4>${desc_item.subtitle}</h4>
                                <p>
                                 ${desc_item.description}
                                </p>
                                </div>
                                `
                              )
                            }).join('')
                          }
                  </div>
              </div>
            </div>
</section>
          `;
          $('.ck_seeds_row').append(html);
          currentPage++; // Increment page number
          isLoading = false; // Reset loading flag
        });
        }else{
           const html = `
            <div class="col-12 my-5">
              <div class="card shadow p-5 text-center">
                    No Data Found              
              </div>
            </div>
           `
            $('.ck_seeds_row').append(html);
             isLoading = true; // Reset loading flag
        }
      }
    })
    
  }
})


  } catch(e) { console.error(e); }
})();
})();
